<template>
  <div class="flex flex-col gap-2 w-full">
    <label
      :for="id"
      class="flex justify-between text-xs dark:text-white text-dark2"
      >{{ label }}
      <slot name="label-addition">
        <span
          v-if="!required"
          data-testId="optional"
          class="text-xs dark:text-dark4 text-dark2"
          >Optional</span
        >
      </slot>
    </label>
    <div
      class="flex justify-center items-center gap-2 bg-dark4 border border-transparent hover:[&:not(:has(input:disabled))]:border-dark4 hover:[&:not(:has(input:disabled))]:border-opacity-50 [&:has(input:focus)]:border-dark4 [&:has(input:focus)]:border-opacity-50 duration-150 rounded-sm px-3 [&:has(input:disabled)]:bg-opacity-20 dark:bg-opacity-5 bg-opacity-30"
    >
      <slot name="prefix"></slot>
      <input
        :id="id"
        v-model.trim="model"
        :type="type"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :aria-required="required"
        class="w-full h-9 py-2 dark:text-white dark:focus:text-white placeholder:opacity-50 placeholder:text-dark4 focus:outline-none placeholder:text-md placeholder:leading-5 bg-transparent disabled:cursor-not-allowed"
      />
      <slot name="postfix"></slot>
    </div>
    <span
      v-if="note"
      class="text-xs dark:text-dark4 text-dark2 text-opacity-50"
    >
      {{ note }}
    </span>
    <span v-if="error" class="text-red-400">{{ error }}</span>
  </div>
</template>
<script setup lang="ts">
  interface InputProps {
    id: string;
    label: string;
    type: 'text' | 'email' | 'password';
    name: string;
    placeholder: string;
    note?: string;
    required?: boolean;
    error?: string;
    disabled?: boolean;
  }

  withDefaults(defineProps<InputProps>(), {
    note: '',
    required: false,
    disabled: false,
    error: ''
  });

  const model = defineModel<string>();
</script>
